"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColorScale = void 0;
var _react = _interopRequireDefault(require("react"));
var _Line = require("./partials/Line");
var _Table = require("./partials/Table");
var _Legend = require("./partials/Legend");
var _ColorScale = _interopRequireDefault(require("./ColorScale.styles"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var ColorScale = function ColorScale(props) {
  var viewMode = props.viewMode,
    data = props.data,
    isLineWithTooltip = props.isLineWithTooltip,
    lineTooltipHeader = props.lineTooltipHeader,
    getValueText = props.getValueText;
  var styles = (0, _ColorScale.default)();
  if (!data || data.length === 0) return null;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: styles['cc-ColorScale'],
    children: [viewMode === 'table' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Table.Table, {
      data: data,
      getValueText: getValueText
    }), viewMode === 'legend' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Legend.Legend, {
      data: data
    }), viewMode === 'line' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Line.Line, {
      data: data,
      isWithTooltip: Boolean(isLineWithTooltip),
      tooltipHeader: lineTooltipHeader,
      getValueText: getValueText
    })]
  });
};
exports.ColorScale = ColorScale;